import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { HelpComponent } from './help.component';

export const HelpRoutes: Routes = [
    {
        path: 'help',
        canActivate: [AuthService],
        children: [
            { path: '', redirectTo: 'help', pathMatch: 'full' },
            {
                path: 'help',
                component: HelpComponent,
            },
        ],
    },
];
